import React from "react";
import Card from "./Card";
import BarTrack from "./BarTrack";
import { formatCurrency, monthShort } from "../utils/format";

// Kolom 3 - wie er de afgelopen twaalf maanden per maand bovenaan stond.
const YearRankList = React.memo(({ yearRankList }) => {
  const maxValue = yearRankList.length
    ? Math.max(...yearRankList.map((entry) => entry.totalPrice))
    : 0;

  return (
    <Card title="Ranglijst afgelopen" label="12 maanden" labelHighlight>
      {yearRankList.length === 0 ? (
        <div className="empty-note">Nog geen historie</div>
      ) : (
        <div className="card-list">
          {yearRankList.map((entry, index) => (
            <div
              key={index}
              className="year-row animate-fade-in"
              style={{ animationDelay: `${index * 0.04}s` }}
            >
              <div className="mo">{monthShort(entry.date)}</div>
              <div className="nm">{entry.name}</div>
              <div className="vl">€{formatCurrency(entry.totalPrice)}</div>
              <BarTrack value={entry.totalPrice} max={maxValue} />
            </div>
          ))}
        </div>
      )}
    </Card>
  );
});

export default YearRankList;
